'use strict';

wbApp.factory('czMsMtRegistrySvc', ['$q', '$resource', 'repositorySvc', 'localStorageService',
    function ($q, $resource, repositorySvc, localStorageService) {
        const CzMsMtRegistry = $resource('/restapi/cz-ms-mt-registry/:id', {}, {
            'getById': {method: 'GET', url: '/restapi/cz-ms-mt-registry/:id'},
            'findByStudent': {method: 'GET', isArray: true, url: '/restapi/cz-ms-mt-registry/find-by-student'},
            'findLatestByActivity': {method: 'GET', isArray: true, url: '/restapi/cz-ms-mt-registry/find-latest-by-activity'},
            'insert': {method: 'POST', url: '/restapi/cz-ms-mt-registry'},
            'update': {method: 'PUT', url: '/restapi/cz-ms-mt-registry/:id'},
            'delete': {method: 'DELETE', url: '/restapi/cz-ms-mt-registry/:id'},
            'lists': {method: 'GET', url: '/restapi/cz-ms-mt-registry/registry-lists' },
            'validate': {method: 'POST', isArray: true,  url: '/restapi/cz-ms-mt-registry/registry-validate'},
            'getStudent': {method: 'GET', url: '/restapi/students/:id' },
            'getActivity': {method: 'GET', url: '/restapi/activities/:id'},
            'export': {method: 'POST', url: '/restapi/cz-ms-mt-registry/registry-export'},
        });
        
        function newExportModel() {
            let model = {
                fromDate: new Date(moment().year() - 1, 9, 1),
                toDate: new Date(moment().year(), 8, 30),
                izo: '',
                cast: '',
                druhProvozu: '1',
                rozliseni: '0',
                prumDobaCelodenniProvoz: 0,
                prumDobaPolodenniProvoz: 0,
                prumDobaInternatniProvoz: 0,
                activityIds: []
            };

            if (localStorageService.isSupported) {
                let izo = localStorageService.get('CzMsMtRegistry-izo');
                if (izo) {
                    model.izo = izo;
                }
                let cast = localStorageService.get('CzMsMtRegistry-cast');
                if (cast) {
                    model.cast = cast;
                }
                let druhProvozu = localStorageService.get('CzMsMtRegistry-druhProvozu');
                if (druhProvozu) {
                    model.druhProvozu = druhProvozu;
                }
                let rozliseni = localStorageService.get('CzMsMtRegistry-rozliseni');
                if (rozliseni) {
                    model.rozliseni = rozliseni;
                }                
            }
            
            return model;
        }

        function fromExportModelToDTO(model) {
            let dto = {
                fromDateUtc: moment(model.fromDate).startOf('day').toDate(),
                toDateUtc: moment(model.toDate).startOf('day').toDate(),
                izo: model.izo,
                cast: model.cast,
                druhProvozu: model.druhProvozu,
                rozliseni: model.rozliseni,
                prumDobaCelodenniProvoz: model.prumDobaCelodenniProvoz,
                prumDobaPolodenniProvoz: model.prumDobaPolodenniProvoz,
                prumDobaInternatniProvoz: model.prumDobaInternatniProvoz,
                activityIds: model.activityIds
            };
            return convertDatesToDateString(dto);
        }

        function saveExportToLocalStorage(model) {
            if (localStorageService.isSupported) {
                localStorageService.set('CzMsMtRegistry-izo', model.izo);
                localStorageService.set('CzMsMtRegistry-cast', model.cast);
                localStorageService.set('CzMsMtRegistry-druhProvozu', model.druhProvozu);
                localStorageService.set('CzMsMtRegistry-rozliseni', model.rozliseni);
            }
        }
        
        function exportToXml(model) {
            let dto = fromExportModelToDTO(model);
            saveExportToLocalStorage(model);
            return repositorySvc.customPostWithParams(
                'export',
                CzMsMtRegistry,
                { },
                dto,
                null,
                null,
                true);            
        }
        
        function saveToLocalStorage(model) {
            if (localStorageService.isSupported) {
                localStorageService.set('CzMsMtRegistry-izo', model.izo);
                localStorageService.set('CzMsMtRegistry-cast', model.cast);
                if (model.activityId) {
                    localStorageService.set(`CzMsMtRegistry-cast-${model.activityId}-provoz`, model.provoz);
                    localStorageService.set(`CzMsMtRegistry-cast-${model.activityId}-jazyK_O`, model.jazyK_O);
                }
            }
        }
        
        function loadFromLocalStorage(model) {
            if (localStorageService.isSupported) {
                let izo = localStorageService.get('CzMsMtRegistry-izo');
                if (izo) {
                    model.izo = izo;
                }
                let cast = localStorageService.get('CzMsMtRegistry-cast');
                if (cast) {
                    model.cast = cast;
                }
                let provoz = localStorageService.get(`CzMsMtRegistry-cast-${model.activityId}-provoz`);
                if (provoz) {
                    model.provoz = provoz;
                }
                let jazyK_O = localStorageService.get(`CzMsMtRegistry-cast-${model.activityId}-jazyK_O`);
                if (jazyK_O) {
                    model.jazyK_O = jazyK_O;
                }
            }
        }
        
        function changeActivityId(model, activityId) {
            return $q(function (resolve, reject) {
                repositorySvc.customGet('getActivity', CzMsMtRegistry, { id: activityId }).$promise.then(
                    function(activity) {
                        model.activityId = activityId;
                        model.trida = activity.name;
                        resolve(model);
                    }, reject);
            });
        }
        
        function createNew(semesterId, activityId) {
            return $q(function (resolve, reject) {
                repositorySvc.customGet('getActivity', CzMsMtRegistry, { id: activityId }).$promise.then(
                    function(activity) {
                        let model = {
                            id: null,
                            studentId: null,
                            semesterId: semesterId,
                            activityId: activityId,
                            trida: activity.name,
                            requireSpecialEducation: false,
                            validFromUtc: new Date(),
                            kstpr: "3",
                            stpr: "203",
                            sP_OBVOD: "1",
                            // obecb
                            koD_ZAH: "1",
                            // prizN_ST: "C"
                            // provoz: "C"
                            jazyK_O: "10",
                            zpusob: "1",
                            koD_VETY: "1",
                            koD_ZMEN: "0",
                        };
                        loadFromLocalStorage(model);
                        resolve(model);
                    },
                    reject
                );
            });
        }
        
        function changeStudentId(model, studentId) {
            return $q(function (resolve, reject) {
                model.studentId = studentId;
                if (!!studentId) {
                    $q.all([
                        findByStudent(model.studentId).$promise,
                        repositorySvc.customGet('getStudent', CzMsMtRegistry, { id: studentId })
                    ]).then(function (data) {
                        let studentRecords = data[0];
                        let student = data[1];
                        if (!!student) {
                            model.rodc = student.personalIDNumber;
                            model.birthday = student.birthday;
                            model.pohlavi = student.gender === 'F' ? '2' : '1';
                        }
                        if (!!studentRecords) {
                            let last = _.find(studentRecords, {isLast: true});
                            if (!!last) {
                                let semesterId = model.semesterId;
                                let activityId = model.activityId;

                                _.assign(model, last);

                                model.semesterId = semesterId;
                                model.activityId = activityId;
                                model.validFromUtc = new Date();
                            } 
                        }
                        resolve(model);
                    }, reject);
                } else {
                    resolve(model);
                }
            });
        }

        function getById(id) {
            return $q(function(resolve, reject) {
                repositorySvc.customGet('getById', CzMsMtRegistry, { id: id }).$promise.then(
                    function(data) {
                        resolve(fromDTOToModel(data));
                    }, reject);
            });
        }
        
        function findByStudent(studentId) {
            let deferred = $q.defer();
            let result = [];
            result.$promise = deferred.promise;
            
            repositorySvc.customGet('findByStudent', CzMsMtRegistry, { studentId: studentId }).$promise.then(
                function(data) {
                    deferred.resolve(_.map(data, fromDTOToModel));
                }, deferred.reject);

            return result;
        }

        function findLatestByActivity(activityId) {
            let deferred = $q.defer();
            let result = [];
            result.$promise = deferred.promise;

            repositorySvc.customGet('findLatestByActivity', CzMsMtRegistry, { activityId: activityId }).$promise.then(
                function(data) {
                    deferred.resolve(_.map(data, fromDTOToModel));
                }, deferred.reject);
            
            return result;
        }

        function insert(model, successCallback, errorCallback) {
            saveToLocalStorage(model);
            let dto = fromModelToDTO(model);
            return repositorySvc.insert(
                CzMsMtRegistry,      // $resource
                null,                // collection
                dto,               // entity
                successCallback,
                errorCallback);
        }

        function update(model) {
            saveToLocalStorage(model);
            let dto = fromModelToDTO(model);
            return repositorySvc.customPutWithParams(
                'update',
                CzMsMtRegistry,      
                { id: dto.id },
                dto);
        }

        function validate(model) {
            let dto = fromModelToDTO(model);
            return repositorySvc.customPostWithParams(
                'validate',
                CzMsMtRegistry,
                { },
                dto,
                null,
                null,
                true);
        }

        function remove(id) {
            return repositorySvc.customDelete(
                'delete',
                CzMsMtRegistry,
                { id: id });
        }

        let listsCache = null;
        
        function lists() {
            if (!listsCache) {
                listsCache = repositorySvc.customGet('lists', CzMsMtRegistry, {});
            }
            
            return listsCache;
        }
        
        function setRequireSpecialEducation(model, requireSpecialEducation) {
            if (!requireSpecialEducation) {
                model.koD_ZAKA = null;
                model.tyP_TR = null;
                model.tyP_TR2 = null;
                model.zvj = null;
                model.nadani = null;
                model.sz = null;
                model.zz = null;
                model.pspo = null;
                model.iD_ZNEV = null;
            }
            else {
                model.koD_ZAKA = model.studentId;
            }
        }
        
        function fromModelToDTO(model) {
            model.validFromUtc = moment(model.validFromUtc).startOf('day').toDate();
            if (model.okresb === '999xxx' && model.okresb2 != null) {
                model.okresb = '999' + model.okresb2;
            }
            
            delete model.okresb2;
            
            return convertDatesToDateString(model);
            // let dto = _.clone(model, true);
            // if (!!dto.iD_ZNEV && Array.isArray(dto.iD_ZNEV) && dto.iD_ZNEV.length > 0) {
            //     dto.iD_ZNEV = dto.iD_ZNEV.join(",");
            // } else {
            //     dto.iD_ZNEV = null;
            // }
            // return dto;
        }
        
        function fromDTOToModel(dto) {
            if (dto.okresb != null && dto.okresb.startsWith('999'))
            {
                dto.okresb2 = dto.okresb.substring(3);
                dto.okresb = '999xxx';
            }
            return dto;
        }

        return {
            createNew: createNew,
            newExportModel: newExportModel,
            findByStudent: findByStudent,
            findLatestByActivity: findLatestByActivity,
            getById: getById,
            insert: insert,
            update: update,
            remove: remove,
            lists: lists,
            setRequireSpecialEducation: setRequireSpecialEducation,
            validate: validate,
            changeStudentId: changeStudentId,
            changeActivityId: changeActivityId,
            exportToXml: exportToXml
        }
    }]);